import { api } from '../../AxiosConfig';

class FinanceiroService {
    previsaoAssinaturas(params?: { from?: string; to?: string }) {
        return api.get('/financeiro/previsao-assinaturas', { params });
    }

    dashboard(params?: { from?: string; to?: string }) {
        return api.get('/financeiro/dashboard', { params });
    }

    dre(params?: { from?: string; to?: string }) {
        return api.get('/financeiro/dre', { params });
    }

    fluxoCaixa(params?: { from?: string; to?: string; mode?: 'cash' | 'competence' }) {
        return api.get('/financeiro/fluxo-caixa', { params });
    }

    settings() {
        return api.get('/financeiro/settings');
    }

    settingsUpdate(data: { subscriptionCommissionBasePercent?: number; defaultPaymentMethod?: string | null }) {
        return api.post('/financeiro/settings/update', data);
    }

    reprocess(data: { startAt: string; endAt: string }) {
        return api.post('/financeiro/reprocess', data);
    }

    paymentDefault() {
        return api.get('/financeiro/settings/payment-default');
    }

    categorias() {
        return api.get('/financeiro/categorias');
    }

    receberFindAll(params?: any) {
        return api.get('/financeiro/receber/findAll', { params });
    }

    receberCreate(data: any) {
        return api.post('/financeiro/receber/create', data);
    }

    receberMarkPaid(data: { id: string; paidAt?: string; accountId?: string; paymentMethod?: string }) {
        return api.post('/financeiro/receber/mark-paid', data);
    }

    receberCancel(data: { id: string }) {
        return api.post('/financeiro/receber/cancel', data);
    }

    pagarFindAll(params?: any) {
        return api.get('/financeiro/pagar/findAll', { params });
    }

    pagarCreate(data: any) {
        return api.post('/financeiro/pagar/create', data);
    }

    pagarMarkPaid(data: { id: string; paidAt?: string; accountId?: string; paymentMethod?: string }) {
        return api.post('/financeiro/pagar/mark-paid', data);
    }

    pagarCancel(data: { id: string }) {
        return api.post('/financeiro/pagar/cancel', data);
    }

    accountsFindAll() {
        return api.get('/financeiro/accounts/findAll');
    }

    accountsCreate(data: any) {
        return api.post('/financeiro/accounts/create', data);
    }

    accountsUpdate(data: any) {
        return api.post('/financeiro/accounts/update', data);
    }

    paymentsCreate(data: any) {
        return api.post('/financeiro/payments/create', data);
    }
}

export { FinanceiroService };
